import { render, staticRenderFns } from "./LetterViewer.vue?vue&type=template&id=006fbe17&scoped=true"
import script from "./LetterViewer.vue?vue&type=script&lang=js"
export * from "./LetterViewer.vue?vue&type=script&lang=js"
import style0 from "./LetterViewer.vue?vue&type=style&index=0&id=006fbe17&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006fbe17",
  null
  
)

export default component.exports